import { create } from "zustand";

export const useLogGameStore = create((set, get) => ({
    playerList: [],
    sessionDate: null,

    clear: () => set({
        playerList : [],
        sessionDate: null
    }),

    setPlayerList: (playerList) => set({ playerList }),
    setSessionDate: (sessionDate) => set({ sessionDate })
    
}));